export default "__VITE_ASSET__BBDLHaaB__"